import { Reveal } from "./Reveal";
import { ScrollColorHeading } from "./ScrollColorHeading";

export const SectionLabel = ({ children, className = "", dark = false }) => (
  <span
    className={`inline-flex items-center gap-3 text-sm uppercase tracking-[0.25em] font-semibold ${dark ? "text-brand-plum/80" : "text-brand-magenta"} ${className}`}
    data-testid="section-label"
  >
    <span className="h-px w-8 bg-current opacity-60" />
    {children}
  </span>
);

export const SectionHeading = ({ label, title, subtitle, dark = false, className = "" }) => (
  <div className={`max-w-3xl ${className}`}>
    {label && (
      <Reveal>
        <SectionLabel dark={dark}>{label}</SectionLabel>
      </Reveal>
    )}
    <Reveal delay={0.1}>
      <ScrollColorHeading
        as="h2"
        text={title}
        className="mt-6 font-heading font-extrabold tracking-tight text-4xl md:text-6xl leading-[1.02]"
      />
    </Reveal>
    {subtitle && (
      <Reveal delay={0.2}>
        <p className={`mt-6 text-lg md:text-xl leading-relaxed ${dark ? "text-brand-plum/70" : "text-brand-ink/75"}`}>
          {subtitle}
        </p>
      </Reveal>
    )}
  </div>
);
